import React from 'react';
import { cls, Column, Grid, Row } from '../../../packages/components';
import './styles/cardEventRecordingSearch.scss';
import WrapperContentPlay from './WrapperContentPlay';
import Utils from '../../../utils/Utils';
import EventTag from '../../../components/PersistentMiniEpg/EventTag';
import { Dates } from '../../../packages/dates/lib/dates';
import EpgPersistence from '../../../AAF/Nepg/EpgPersistence';
import { calculateProgress } from '../../../components/PersistentMiniEpg/Helpers/Utils';
import NpvrUploader from '../../../AAF/Npvr/NpvrUploader';
import { NpvrUtil } from '../../../AAF/Npvr/NpvrUtil';
import {
    NPRV_SCHEDULED_STATUS,
    NPVR_RECORDING_STATUS,
    NPVR_RECORDED_STATUS
  } from '../../../AAF/Npvr/Constans';
  import Asset from '../../../requests/apa/Asset';
import store from 'src/store';
import { HIDE_MODAL, MODAL_PIN, showModal } from 'src/actions/modal';
import { MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER, MP_CHECAR_STATUS } from 'src/components/Modal/ModalPinCode';
import { Pin } from '../../../AAF/Pin/main';
import CardBlockedChannel from './CardBlockedChannel';
import UtilsSearch from '../UtilsSearch';


const getLeftElement = (contentItem) => {
    let image =
        (contentItem.ext_eventimage_name &&
            contentItem.ext_eventimage_name !== '' &&
            contentItem.ext_eventimage_name) ||
        contentItem.channel_image;
    if (image === '' || image == null) {
        image = '/images/placeholder_landscape.png';
    }

    const blockedChannel = Pin.blockedChannelsList().includes(contentItem.channel_group_id)

    return (
        <div className={cls(`aaf-main-search-card-event-recording-main`)}>
            <div
                className={cls('aaf-main-search-card-event-recording-main-container')}
                id={`modal_episode_number_${contentItem.idx_temp || null}`}
                data-id={contentItem.idx_temp || null}
            >
                <div className="aaf-main-search-card-event-recording-main-image">
                    {blockedChannel && <CardBlockedChannel/>}
                    <div
                        className={cls('aaf-main-search-card-event-recording-main-image-div')}
                        style={{
                            backgroundImage: 'url(' + image + ')',
                            backgroundPosition: `center`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            'background-color': '#2d2d2d'
                        }}>
                    </div>
                    {/* {badges && <div className={`aaf-main-search-card-event-recording-main-badge-container`} dangerouslySetInnerHTML={createMarkup(badges)} />} */}
                </div>
            </div>
        </div>
    );
};

const getDate = (contentItem) => {
    const isEventNow = isNow(contentItem);
    let result = '';
    if(!isEventNow){
        const startDate =  EpgPersistence.needsOffset() ? new Dates().unix(contentItem.unix_begin).utcOffset(EpgPersistence.needsOffset(), false): new Dates().unix(contentItem.unix_begin);
        if(startDate && (typeof startDate.date == 'function') ){
            let monthName =  startDate.format('MMM.');
            if(monthName && (typeof monthName === 'string')){
                monthName =  Utils.capitalize(monthName);
                const day =  startDate.date();
                result = `${day} ${monthName} | `;
            }
        }

    }

    if (contentItem && contentItem.unix_begin && contentItem.unix_end) {
        const dateStart = `${
            EpgPersistence.needsOffset()
                ? new Dates()
                      .unix(contentItem.unix_begin)
                      .utcOffset(EpgPersistence.needsOffset(), false)
                      .format('HH:mm')
                : new Dates().unix(contentItem.unix_begin).format('HH:mm')
        }`;
        const dateEnd = `${
            EpgPersistence.needsOffset()
                ? new Dates()
                      .unix(contentItem.unix_end)
                      .utcOffset(EpgPersistence.needsOffset(), false)
                      .format('HH:mm')
                : new Dates().unix(contentItem.unix_end).format('HH:mm')
        }`;
        return `${result}${dateStart} - ${dateEnd}`;
    }
};


const getTimeEventRecorded = (contentItem) =>{
        let result = '';
        const startDate =  EpgPersistence.needsOffset() ? new Dates().unix(contentItem.unix_begin).utcOffset(EpgPersistence.needsOffset(), false): new Dates().unix(contentItem.unix_begin);
        if(startDate && (typeof startDate.date == 'function') && (typeof startDate.year == 'function')){
            let monthName =  startDate.format('MMM.');
            if(monthName && (typeof monthName === 'string')){
                monthName =  Utils.capitalize(monthName);
                const day =  startDate.date();
                const year =  startDate.year();
                // const duration = (contentItem && contentItem.duration) ? Utils.formatDuration(contentItem.duration) : '';
                result = `${day} ${monthName} | ${year}`;
            }
        }
        return result;
}

const getDuration  = (contentItem) =>{
    return (contentItem && contentItem.duration) ? Utils.formatDuration(contentItem.duration) : '';
}

const getPercent = (contentItem) => {
    if (contentItem && contentItem.unix_begin && contentItem.unix_end) {
        // const dateStart = EpgPersistence.needsOffset() ? new Dates().unix(contentItem.unix_begin).utcOffset(EpgPersistence.needsOffset(), false) : new Dates().unix(contentItem.unix_begin);
        // const dateEnd = EpgPersistence.needsOffset() ? new Dates().unix(contentItem.unix_end).utcOffset(EpgPersistence.needsOffset(), false) : new Dates().unix(contentItem.unix_end);
        // const start_unix = dateStart.unix();
        // const end_unix = dateEnd.unix();
        return calculateProgress(contentItem.unix_begin, contentItem.unix_end);
    }
    return false;
};

const getRightElement = (contentItem, asset = {}, status, isReminder = false) => {
    const tilte = (contentItem && contentItem.name) || ' ';
    const {
        channel_group: { common: { channel_number = null } = {} } = {},
        channel_name = '',
        unix_begin = null,
        unix_end = null,
    } = contentItem;
    const {imageSrc = null, label = null} = asset;
    const subtitleName = `${channel_number} | ${channel_name}`;
    const eventNotRecorded = (status && status.recording_status && (status.recording_status !== NPVR_RECORDED_STATUS));

    return (
        <Grid className={cls('aaf-main-search-card-event-recording-main-right')}>
            <Row className={cls('aaf-main-search-card-event-recording-main-right-row')}>
                <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-title'
                    )}>
                    {UtilsSearch.cutString(tilte, 19)}
                </Column>
                {eventNotRecorded && <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-channel-name'
                    )}>
                    {UtilsSearch.cutString(subtitleName)}
                </Column>}
                {!eventNotRecorded && <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-channel-duration'
                    )}>
                    {UtilsSearch.cutString(getTimeEventRecorded(contentItem))}
                </Column>}
                {!eventNotRecorded && <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-channel-duration'
                    )}>
                    {UtilsSearch.cutString(getDuration(contentItem))}
                </Column>}
                {eventNotRecorded && <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-status-event'
                    )}>
                    <img
                        src={Asset.get('content_data_livechannel_icon', '/images/tvIconSmall.png')}
                        className={cls(
                            'aaf-main-search-card-event-recording-main-right-column-status-event-icon'
                        )}
                    ></img>
                    <EventTag
                        wrapperId={'modal_1'}
                        spanId={'modal_span_id'}
                        startTime={unix_begin}
                        endTime={unix_end}
                    />
                    {
                        <img src={imageSrc} className={'aaf-main-search-card-event-recording-main-right-column-channel-icon-img-normal'}/>
                    }
                    {
                        isReminder && <img
                        src={Asset.get('playingLive_programFuture_option_button_reminder', '/images/ic_clock.png')}
                        className={cls(
                            'aaf-main-search-card-event-recording-main-right-column-status-event-icon', 'aaf-main-search-card-event-recording-main-right-column-status-event-icon-reminder'
                        )}
                    ></img>
                    }
                </Column>
                }
                {eventNotRecorded && <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-status-date'
                    )}>
                    {getDate(contentItem)}
                </Column>}
                {!eventNotRecorded && <Column
                    lg={12}
                    className={cls(
                        'aaf-main-search-card-event-recording-main-right-column',
                        'aaf-main-search-card-event-recording-main-right-column-channel-icon'
                    )}>
                    <img src={imageSrc} className={'aaf-main-search-card-event-recording-main-right-column-channel-icon-img'}/>
                    <span className={'aaf-main-search-card-event-recording-main-right-column-channel-icon-label'}>{label}</span>
                </Column>}
            </Row>
        </Grid>
    );
};

const isNow = (event) => {
    if (!event) return false;
    return Utils.isDateBetween(event.date_begin, event.date_end);
};

const isFuture = (event) => {
    if (!event) return false;
    return Utils.isCurrentEventFuture({ event: event });
};

const isPast = (event) => {
    if (!event) return false;
    return event.endtime && Utils.isDateBetween(event.endtime, Utils.now(true).unix());
};

const flowStatusRecording = (item, status, handleRecordingPlay, showModalOptions, sendPlayLive) => {
  if(status && status.recording_status){
    switch(status.recording_status){
        case NPVR_RECORDED_STATUS:
            // ES RECORDING YA INGESTADO
            const recording = item && NpvrUploader.getAllRecordingStatusByEventId(item.event_alf_id);
            const itemNew = {...item, ... recording};
            handleRecordingPlay && (typeof handleRecordingPlay === 'function') && handleRecordingPlay(itemNew);
        return;
        case NPRV_SCHEDULED_STATUS:
            showModalOptions && (typeof showModalOptions === 'function') && showModalOptions(item);
        return;
        case NPVR_RECORDING_STATUS:
            sendPlayLive && (typeof sendPlayLive === 'function') && sendPlayLive(item);
        return;
        default:
            return;
    }
  }
}

const handleCloseModalPin = () => {
  UtilsSearch.updateDataStoreSearcher({isFlowSearcherForPin: false});
  store.dispatch(
    showModal({
        modalType: HIDE_MODAL,
        modalProps: {},
    })
  );

}

const successCallBack = (item, status, handleRecordingPlay, showModalOptions, sendPlayLive) => {
  UtilsSearch.updateDataStoreSearcher({isFlowSearcherForPin: false});
  flowStatusRecording(item, status, handleRecordingPlay, showModalOptions, sendPlayLive)
}


const handleModalPin = (item, status, handleRecordingPlay, showModalOptions, sendPlayLive) => {
  const modal = {
    modalType: MODAL_PIN,
    modalProps: {
        type: MODAL_PIN_CODE_LOCK_CHANNEL_TYPE_SEARCHER,
        action: MP_CHECAR_STATUS,
        successCallBack: () => successCallBack(item, status, handleRecordingPlay, showModalOptions, sendPlayLive),
        failedCallBack: handleCloseModalPin,
        cancelCallBack: handleCloseModalPin,
    },
  };
  store.dispatch(showModal(modal));
};

const onClick = (item, playFullMedia = null, isPlay = false, status, handleRecordingPlay = null, showModalOptions = null, sendPlayLive=null) => {
    UtilsSearch.updateDataStoreSearcher({isFlowSearcherForPin: true});

    const isBlockedChannel = Pin.blockedChannelsList().includes(item.channel_group_id);

    isBlockedChannel
    ? handleModalPin(item, status, handleRecordingPlay, showModalOptions, sendPlayLive)
    : flowStatusRecording(item, status, handleRecordingPlay, showModalOptions, sendPlayLive);
};

const CardRecordingSearch = ({ onFocus = null, item = {}, playFullMedia = null, handleRecordingPlay, showModalOptions = null, sendPlayLive=null, isReminder = false}) => {
    let isplay =  false;
    const status =  NpvrUploader.getAllRecordingStatusByEventId(item.event_alf_id);
    let asset = {};

    if(status && status.recording_status){
        asset = NpvrUtil.getRecordingAsset(status.recording_status);
        const {actions: {play = false} = {} } = status || {};
        isplay = status.recording_status === NPVR_RECORDED_STATUS && play
    }

    return (
        <WrapperContentPlay
            children_left={getLeftElement(item)}
            children_right={getRightElement(item, asset, status, isReminder)}
            onClick={() => {
                onClick(item, playFullMedia, isplay, status, handleRecordingPlay, showModalOptions, sendPlayLive);
            }}
            isPlay={isplay}
            item={item}
            onFocus = {onFocus}
        />
    );
};

export default CardRecordingSearch;



// WEBPACK FOOTER //
// ./src/containers/Search/components/CardRecordingSearch.jsx